export default __webpack_public_path__ + "static/media/KOD0137-min.4b57bb65.webp";